import script from "./ComfortSpot.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComfortSpot.vue?vue&type=script&setup=true&lang=ts"

import "./ComfortSpot.vue?vue&type=style&index=0&id=03c23ec2&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03c23ec2"]])

export default __exports__